module.exports = __webpack_public_path__ + "img/moderation_success_my.30e4f425.svg";